module.exports = __webpack_public_path__ + "img/logo-hmh.6bac9cf7.png";